import { render, staticRenderFns } from "./ClientExportButton.vue?vue&type=template&id=327c0bdb"
import script from "./ClientExportButton.vue?vue&type=script&lang=js"
export * from "./ClientExportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports